import React from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AffiliateLayout from "./affiliate/AffiliateLayout";

const AppLayout = () => {
  const { isAdmin } = useAuth();

  // Non-admins (affiliates) are directed to their specific layout
  // We will handle the redirect logic to /affiliate/:affiliateName elsewhere
  // For now, this component mainly serves to structure admin views
  if (!isAdmin) {
    // This will render the nested affiliate routes correctly
    return <Outlet />;
  }

  // Admin users get a simpler layout that provides the main content area
  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {/* We can add a common admin header/nav here later if needed */}
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default AppLayout;
